import {useState, forwardRef, useImperativeHandle, useRef, useCallback } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export const AwaitModalComponent = forwardRef((props, ref) => {
    forwardRef(props, ref)
    const modalRef = useRef();

    const [showing, setShowing] = useState(false);

    const promiseRef = useRef();
    const onClose=(response) => {
        setShowing(false);
        if (promiseRef.current) {
            promiseRef.current.resolve(response)
        }
        promiseRef.current = null
    };


    useImperativeHandle(ref, () => ({
        show: () => {
            setShowing(true);
            return new Promise((resolve, reject) => {
                promiseRef.current = {resolve, reject};
            })
        }
    }));


    return showing && <Modal
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    ref={modalRef}
    >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                {props.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {props.body}
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={()=>onClose(true)}>Confirm</Button>
            <Button onClick={()=>onClose(false)}>Cancel</Button>
        </Modal.Footer>
    </Modal>
});